import { render, staticRenderFns } from "./TemlikForm.vue?vue&type=template&id=145960ce"
import script from "./TemlikForm.vue?vue&type=script&lang=ts"
export * from "./TemlikForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports